// payoutmanagement/BankCodeModal.jsx — 은행코드 관리 모달
// 동적 관리(TicketTypeManagement) 내 버튼에서도, 정산 관리 내에서도 열 수 있음

import React, { useState } from 'react';
import { useBodyScrollLock } from '../../../hooks/useBodyScrollLock';
import { useOverlayClickClose } from '../../../hooks/useOverlayClickClose';
import { stdModalHeaderBar, stdModalHeaderIconBox, stdModalHeaderTitle, stdModalCloseBtn } from '../adminlayout/designStandard';

export function BankCodeModal({ bankCodesAll, loading, onAdd, onToggle, onClose }) {
  useBodyScrollLock(true);
  const overlayCloseProps = useOverlayClickClose(onClose);
  const [newCode, setNewCode] = useState('');
  const [newName, setNewName] = useState('');

  const handleAdd = () => {
    const c = newCode.trim();
    const n = newName.trim();
    if (!c || !n) return;
    onAdd(c, n);
    setNewCode('');
    setNewName('');
  };

  // ── 스타일 ──────────────────────────────────────────────────────────────────
  const ovSt = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 2000,
    display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
    padding: 'max(10px, env(safe-area-inset-top)) 12px max(10px, env(safe-area-inset-bottom))',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
  };
  const boxSt = {
    background: 'var(--bg-card)', borderRadius: 14,
    width: 'min(480px, calc(100vw - 24px))',
    maxWidth: 'calc(100vw - 24px)',
    maxHeight: 'min(90vh, calc(100dvh - 20px))',
    marginTop: 10,
    overflow: 'hidden',
    display: 'flex', flexDirection: 'column',
    boxSizing: 'border-box',
    boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
  };
  const listSt = { flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: '12px 16px', minWidth: 0 };
  const rowSt = (active) => ({
    display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0',
    borderBottom: '1px solid var(--border)',
    opacity: active ? 1 : 0.4,
    minWidth: 0,
  });
  const addRowSt = {
    display: 'flex', gap: 8, padding: '12px 16px',
    borderTop: '1px solid var(--border)', alignItems: 'center',
    flexWrap: 'wrap',
    minWidth: 0,
  };
  const inpSt = {
    border: '1.5px solid var(--border)', borderRadius: 8, padding: '6px 10px',
    fontSize: 13, color: 'var(--text)', background: 'var(--bg-card)', outline: 'none',
    minWidth: 0,
    boxSizing: 'border-box',
  };
  const btnSt = {
    border: 'none', borderRadius: 8, padding: '6px 14px',
    background: '#2563eb', color: '#fff', fontSize: 12, fontWeight: 700,
    cursor: 'pointer', whiteSpace: 'nowrap',
  };
  const toggleBtnSt = (active) => ({
    border: `1px solid ${active ? '#dc2626' : '#059669'}`, borderRadius: 6,
    padding: '3px 10px', fontSize: 11, fontWeight: 600, cursor: 'pointer',
    background: 'transparent',
    color: active ? '#dc2626' : '#059669',
  });

  return (
    <div style={ovSt} {...overlayCloseProps}>
      <div style={boxSt}>
        {/* 헤더 — 검정 표준 밴드 */}
        <div style={stdModalHeaderBar(14)}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            <div style={stdModalHeaderIconBox}>🏦</div>
            <span style={stdModalHeaderTitle}>은행코드 관리</span>
          </div>
          <button style={stdModalCloseBtn} onClick={onClose}>✕</button>
        </div>

        {/* 목록 */}
        <div style={listSt}>
          {loading ? (
            <div style={{ padding: 24, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>불러오는 중...</div>
          ) : (
            bankCodesAll.map((b) => (
              <div key={b.id} style={rowSt(b.is_active)}>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', minWidth: 40 }}>{b.code}</span>
                <span style={{ fontSize: 13, color: 'var(--text-sub)', flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.name}</span>
                <button style={toggleBtnSt(b.is_active)} onClick={() => onToggle(b.id, b.is_active)}>
                  {b.is_active ? '비활성' : '활성화'}
                </button>
              </div>
            ))
          )}
        </div>

        {/* 추가 입력 */}
        <div style={addRowSt}>
          <input style={{ ...inpSt, width: 72, flex: '0 0 72px' }} placeholder="코드" value={newCode} onChange={(e) => setNewCode(e.target.value)} />
          <input style={{ ...inpSt, flex: '1 1 160px' }} placeholder="은행명" value={newName} onChange={(e) => setNewName(e.target.value)} />
          <button style={btnSt} onClick={handleAdd}>추가</button>
        </div>
      </div>
    </div>
  );
}
